"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var onQuickOptionToggle_1 = require("owa-options-actions/lib/onQuickOptionToggle");
var satcheljs_1 = require("satcheljs");
var owa_analytics_1 = require("owa-analytics");
var QUICK_SETTINGS_TOGGLE_USAGE_KEY = 'quickSettingsToggle';
exports.default = satcheljs_1.orchestrator(onQuickOptionToggle_1.default, function (actionMessage) {
    var option = actionMessage.option, isToggledOn = actionMessage.isToggledOn;
    owa_analytics_1.logUsage(QUICK_SETTINGS_TOGGLE_USAGE_KEY, {
        optionKey: option.key,
        isToggledOn: "" + isToggledOn,
    });
    var onToggle = option.quickOptionSettings.rendering.onToggle;
    if (onToggle) {
        onToggle(isToggledOn);
    }
});
//# sourceMappingURL=toggleQuickOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/toggleQuickOption.js
// module id = 5284
// module chunks = 2